import OBuyTicketModal from './o-buy-ticket-modal.vue';

export default OBuyTicketModal;